import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { EntityState } from '@/shared/types/entity';
import { blockedCheckoutsApi } from '../api';
import type { BlockedCheckoutFilters, BlockedCheckoutLog } from '../types';

const initialState: EntityState<BlockedCheckoutLog, BlockedCheckoutFilters> = {
  items: [] as BlockedCheckoutLog[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 20,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
    dateFrom: null,
    dateTo: null,
  },
};

const { actions, reducer } = createEntitySlice<BlockedCheckoutLog, BlockedCheckoutFilters, never>({
  name: 'blockedCheckoutsEntity',
  api: {
    getList: blockedCheckoutsApi.getList,
    getOne: () => Promise.reject(new Error('Blocked checkout logs are read-only')),
    create: () => Promise.reject(new Error('Blocked checkout logs are read-only')),
    update: () => Promise.reject(new Error('Blocked checkout logs are read-only')),
    delete: () => Promise.reject(new Error('Blocked checkout logs are read-only')),
  },
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.blockedCheckoutsEntity;
    const params: Record<string, unknown> = { page: currentPage, perPage };
    if (filters.search) params.search = filters.search;
    if (filters.dateFrom) params.dateFrom = filters.dateFrom;
    if (filters.dateTo) params.dateTo = filters.dateTo;
    return params;
  },
});

export const {
  fetchItems: fetchBlockedCheckouts,
  setPage: setBlockedCheckoutsPage,
  setPerPage: setBlockedCheckoutsPerPage,
  setFilters: setBlockedCheckoutsFilters,
} = actions;

export const blockedCheckoutsReducer = reducer;
